import dayjs from "dayjs";
import { useEffect } from "react";
import { useRecoilState } from "recoil";

import { sendEventToAppMeasurementTool, AppEventTokenEnum } from "@/utilities/capacitorLogic";
import { useSelectOwnedProperties, SelectedStartingMonth, SelectedEndingMonth } from "@/view_models/atoms";

// MyPageの初期化フック
export const useMyPageInitialization = () => {
  const [selected_starting_month, setSelectedStartingYear] = useRecoilState(SelectedStartingMonth);
  const [selected_ending_month, setSelectedEndingYear] = useRecoilState(SelectedEndingMonth);
  const selectOwnedProperties = useSelectOwnedProperties();

  useEffect(() => {
    // マイページ遷移イベント発火
    sendEventToAppMeasurementTool(AppEventTokenEnum.UserMypageAccess);

    selectOwnedProperties();
    if (selected_ending_month.diff(selected_starting_month, "year") !== 45) {
      setSelectedStartingYear(dayjs().startOf("year"));
      setSelectedEndingYear(dayjs().add(45, "year").endOf("year"));
    }
  }, []);

  return {
    selected_starting_month,
    selected_ending_month,
  };
};
